<h2>Line Setup</h2>
<div class="actions">
  <input #filePicker
         type="file"
         accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
         (change)="this.onFileSelected($event)"
         style="display:none">
  <button mat-button (click)="filePicker.click()">
    <mat-icon>upload</mat-icon>UPLOAD EXCEL FILE
  </button>
</div>

<app-spinner [promise]="this.lineDiffFetchPromise"
             friendlyErrorMessage="Previewing the Line Setup document failed."
             correctionAdvice="Please ensure it is in the correct format and try again."></app-spinner>

<app-spinner [promise]="this.applyChangesPromise"
             friendlyErrorMessage="Applying the Line Setup document failed."
             correctionAdvice="Please contact support for assistance."></app-spinner>

<div *ngIf="this.changesApplied" class="centering-container all-done">
  <div>
    <mat-icon>check_circle</mat-icon>
  </div>
  <div>
    Changes Applied
  </div>
</div>

<ng-container *ngIf="this.lineDiff && !this.changesApplied && !this.applyChangesPromise">
  <h3>Preview of changes made by {{this.diffWorkbookFile!.name}}</h3>

  <div class="factory-line-details">
    <span class="label">Factory:</span>

    <mat-icon *ngIf="this.lineDiff.factory.isNew">fiber_new</mat-icon>
    <span>{{this.lineDiff.factory.name}}</span>
    <span class="flex-spacer"></span>
    <span class="label">Line:</span>
    <mat-icon *ngIf="this.lineDiff.line.isNew">fiber_new</mat-icon>
    <span>{{this.lineDiff.line.name}}</span>
    <span class="flex-spacer"></span>
    <span class="flex-spacer"></span>
  </div>

  <mat-tab-group animationDuration="0ms">
    <mat-tab>
      <ng-template mat-tab-label>
        <span>Line Products</span>
        <span>&nbsp;</span>
        <span class="added">+{{this.addedLineProductCount}}</span>
        <span>/</span>
        <span class="removed">-{{this.removedLineProductCount}}</span>
      </ng-template>
      <div class="tab-content">
        <ul>
          <li *ngFor="let product of this.lineProducts"
              [class.added]="product.isNew"
              [class.removed]="product.isRemoved">
            {{product.name}}
          </li>
        </ul>
      </div>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span>Line Tasks</span>
        <span>&nbsp;</span>
        <span class="added">+{{this.addedLineTaskCount}}</span>
        <span>/</span>
        <span class="removed">-{{this.removedLineTaskCount}}</span>
      </ng-template>
      <div class="tab-content">
        <ul>
          <li *ngFor="let task of this.lineTasks"
              [class.added]="task.isNew"
              [class.removed]="task.isRemoved">
            <div class="line-task">
              <div class="header">
                <span>{{task.name}}</span>
                <span class="flex-spacer"></span>
                <span>{{task.standardTimeInMinutes}} minutes</span>
              </div>
              <pre class="details">{{task.details}}</pre>
            </div>
          </li>
        </ul>
      </div>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span>Changeover Types</span>
        <span>&nbsp;</span>
        <span class="added">+{{this.addedChangeoverTypeCount}}</span>
        <span>/</span>
        <span class="modified">Δ{{this.modifiedChangeoverTypeCount}}</span>
        <span>/</span>
        <span class="removed">-{{this.removedChangeoverTypeCount}}</span>
      </ng-template>
      <div class="tab-content">
        <ul>
          <li *ngFor="let changeoverType of this.changoverTypes"
              [class.added]="changeoverType.isNew"
              [class.modified]="changeoverType.isModified"
              [class.removed]="changeoverType.isRemoved">
            <div class="changeover-type">
              <div class="header">
                <span class="ingestion-number">{{changeoverType.ingestionNumber}}</span>
                <span>{{changeoverType.description}}</span>
                <span class="flex-spacer"></span>
                <span>{{changeoverType.standardTimeInMinutes}} minutes</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </mat-tab>
  </mat-tab-group>

  <div class="footer">
    <span class="flex-spacer"></span>
    <button type="button"
            aria-label="Finalise"
            color="primary"
            mat-raised-button
            (click)="this.applyChanges($event)">
      APPLY CHANGES
    </button>
  </div>
</ng-container>